import { Component, OnInit, Inject } from '@angular/core';
import { TslOverlayRef } from '@tesla/ng-tds';

@Component({
    selector: 'location-help-content',
    styleUrls: [],
    template: `<div class='content-overlay'><div style='width:400px;font-family:sans-serif'>
    <p style='padding:10px'>Is the tool in service? If the tool is a Tesla Asset, the Tool status is tied with the status of the Asset, which is again tied to the demand status of the Associated Part Numbers. In order to update the tool status, add the associated Tesla Part Numbers and select the appropriate Asset status.<br></p>
    </div></div>`
})

export class StatusHelpContent {

    constructor(
        private overlayRef: TslOverlayRef<StatusHelpContent>
    ) { }

    close() {
        this.overlayRef.close();
    }
}